import React, { useEffect, useState } from "react";
import MDBox from "../../components/MDBox";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import DeleteModal from "./DeleteModal";
import { useRecoilState } from "recoil";
import { campaignsState } from "../../recoilStates";
import { getStoreCampaigns } from "../../assets/firebaseFirestore";
import CampaignCard from "./CampaignCard";

const Index = () => {

  const [modal, setModal] = useState(null);
  const [campaigns, setCampaigns] = useRecoilState(campaignsState);


  const updateCampaigns = () => {
    getStoreCampaigns().then((res) => {
      setCampaigns(res)
    });
  }




  useEffect(() => {
    updateCampaigns()
  }, []);


  return (
    <DashboardLayout>
      <DashboardNavbar />

      {
        modal ? <DeleteModal getUpdate={updateCampaigns} modal={modal} setModal={setModal} />
          : ""
      }

      <Card>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h5" fontWeight="medium">
            Campaigns
          </MDTypography>
          <Link to={"create"}>
            <MDButton variant="gradient" color="primary">
              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
              &nbsp;Create campaign
            </MDButton>
          </Link>
        </MDBox>

        <MDBox pt={1} pb={2} px={2}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>

            {
              campaigns.map((campaign, index) => (
                <CampaignCard key={`Campaign-${index}`} setModal={setModal} data={campaign}
                />
              ))
            }

          </MDBox>
        </MDBox>

      </Card>

    </DashboardLayout>
  );
};

export default Index;
